/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: fangpu
 * @LastEditTime: 2023-05-09 11:44:06
 * @Description:
 */
import $ from 'webpack-zepto';
import _ from 'underscore';
import '@/core/config';
import User from '@/core/user';
import Vue from 'vue';

export default class Service {
  /**
   * 请求入口
   * @param {string} path 请求的路径
   * @param {object} opts 请求
   */
  static doRequest(path, opts) {
    const promise = new Promise((resolve, reject) => {
      let queryParams = Object.assign({
        p: 'w',
        v: 'v4.17.0'
      }, opts.queryParams || {});

      const data = {};
      if (User.uid()) {
        data.uid = User.uid();
      }
      if (User.appId()) {
        data.wechatAppId = User.appId();
      }
      if (User.token()) {
        data.token = User.token();
      }
      if (getParameterByName('sid')) {
        data.sid = getParameterByName('sid');
      }
      if (User.openId()) {
        data.openId = User.openId();
      }

      queryParams = Object.assign(queryParams, data);

      try {
        if (opts.isLogin) {
          queryParams.token = window.localStorage.getItem('h5_token') && window.localStorage.getItem('h5_token').replace(/"/g, '');
          queryParams.uid = window.localStorage.getItem('h5_uid') && window.localStorage.getItem('h5_uid').replace(/"/g, '');
          queryParams.aid = window.localStorage.getItem('h5_aid') && window.localStorage.getItem('h5_aid').replace(/"/g, '');
          queryParams.cid = window.localStorage.getItem('h5_cid') && window.localStorage.getItem('h5_cid').replace(/"/g, '');
          queryParams.p = 'wx'
        }
      } catch (error) {

      }




      let url = path;
      if (queryParams) {
        url += '?' + $.param(queryParams);
      }
      let serverPath = drServer || window.CONFIG.server;
      if (SERVER) {
        serverPath = drServer || SERVER;
      }

      if (!opts.heimdall && (url.indexOf('c/') != -1 || url.indexOf('wheat/') != -1 || url.indexOf('h/') != -1)) {
        serverPath += 'api-c/'
      }
      url = serverPath + url;
      const params = opts.params;
      if (opts.isSass) {
        url = url.replace(/heimdall/, "api-b");
      }
      if (opts.isM) {
        url = url.replace(/heimdall/, "api-m")
      }
      const headers = {
        appId: User.appId() || "",
        openId: User.openId() || "",
        userId: User.uid() || '',
        xmToken: User.token() || '',
        product:'customer',
        sid: getParameterByName('sid') || '',
        userType: 'C',
      }
      if (sessionStorage.getItem('brandMiniapp')) {
        headers.tenantId = sessionStorage.getItem('brandTenantId') || sessionStorage.getItem('brandInstId');
        headers.tenantType = sessionStorage.getItem('brandTenantType') || sessionStorage.getItem('brandInstType') || 'INST';
      }
      const ajaxOptions = {
        data: params || opts.data,
        type: opts.type || 'POST',
        url,
        contentType: opts.contentType || 'application/x-www-form-urlencoded; charset=UTF-8',
        timeout: 20000,
        headers,
        dataType: opts.dataType || 'json',
        processData: opts.processData || true,
        beforeSend(xhr, settings) {
          opts.beforeSend && opts.beforeSend(xhr);
        },
        success(res, status, xhr) {
          if (opts.heimdall && res.success) {
            resolve(res);
            return
          }
          if (res.resultCode === 0 || opts.reject) {
            const data = Service.processSuccessData(res);
            opts.success && opts.success(data);
            resolve(res);
          } else {
            if (res.resultCode === 1102) {
              User.loginIn();
              return;
            } else if (res.resultCode === -11) {
              // window.location.reload()
            } else if (res.resultCode === 45) {
              Service.processRequestError(res);
              setTimeout(() => {
                WeixinJSBridge.invoke('closeWindow');
              }, 1000)
            } else if (res.resultCode === 26) {
              windowVERSION
                .showConfirm(
                  "提示",
                  res.data,
                  "确定",
                  "",
                  false
                )
            } else {
              Service.processRequestError(res);
              window.hideLoading();
            }
          }
        },
        error(xhr, errorType, error) {
          Service.processHttpError(xhr, errorType, error);
          reject(xhr, errorType, error);
        },
        complete(xhr, status) {
          opts.complete && opts.complete(xhr, status);
        }
      };

      if (opts.contextPath) {
        ajaxOptions.headers['xm_tag'] = opts.conteVERSIONxtPath;
      }

      if (opts.msgIds) {
        ajaxOptions.headers['xm_msg_ids'] = opts.msgIds;
      }

      $.ajax(ajaxOptions);
    });

    return promise.catch((xhr, errorType, error) => {
      opts.error && opts.error(error);
      return new Promise((resolve, reject) => {
        reject(error);
      });
    });
  }

  //异步请求
  static doAsyncRequest(path, opts) {
    opts = Object.assign(opts || {}, {
      async: true
    });
    if (_.isUndefined(opts.queryUserInfo)) {
      opts.queryUserInfo = true;
    }
    return Service.doRequest(path, opts);
  }

  static processSuccessData(data) {
    if (!data) {
      return {};
    }
    if (data && typeof data === 'string') {
      return JSON.parse(data);
    }

    return data;
  }

  static processRequestError(res) {
    Vue.$wheatToast({
      message: res.resultMsg || res.message,
      position: "middle"
    });
  }

  static processHttpError(xhr, errorType, error) {
    let message = '';
    if (xhr.status === 404) {
      message = '404 网络错误 \n 请检查你的本地网络是否连接';
    } else if (xhr.status === 500) {
      message = 'Oops! 500错误 \n 服务器异常';
    } else if (xhr.status === 0) {
      return;
    } else {
      message = '加载中';
    }
    Vue.$wheatToast({
      message: message,
      position: "middle"
    });
  }
};





// WEBPACK FOOTER //
// ./src/service/Service.js